import { Controller } from '@hotwired/stimulus';

// ボタンで対象要素の表示/非表示を切り替える汎用トグル。
// connect で閉状態へ初期化するのは、Turbo の復元訪問（戻る操作）でも既定閉を保つため。
export default class extends Controller {
  static targets = ['content', 'button'];

  static values = { openLabel: String, closeLabel: String };

  connect() {
    this.close();
  }

  toggle() {
    if (this.contentTargets.some((element) => element.hidden)) {
      this.open();
    } else {
      this.close();
    }
  }

  open() {
    this.contentTargets.forEach((element) => {
      element.hidden = false;
    });
    this.buttonTarget.textContent = this.closeLabelValue;
    this.buttonTarget.setAttribute('aria-expanded', true);
    this.dispatch('toggled');
  }

  close() {
    this.contentTargets.forEach((element) => {
      element.hidden = true;
    });
    this.buttonTarget.textContent = this.openLabelValue;
    this.buttonTarget.setAttribute('aria-expanded', false);
    this.dispatch('toggled');
  }
}
